// NPM Imports
import React, { Component } from "react";
import { connect } from "react-redux";
// import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "../../revvComponents";

// Components Imports
import QuickReviewIcon from "../QuickReview/QuickReviewIcon";
// import RecipientDocHeaderDownloadButton from "../RecipientDocHeader/RecipientDocHeaderButtons/RecipientDocHeaderDownloadButton";
import RecipientDocHeaderMoreBtn from "../RecipientDocHeader/RecipientDocHeaderButtons/RecipientDocHeaderMoreBtn";
import EsignDocHeaderEvidenceSummary from "./EsignDocHeaderEvidenceSummary";
// Actions Imports
import { QuotationActions } from "../../actions";
import { dateDiff } from "../../utils/globalUtils";

// Destructuring
const { updateToolPaneData } = QuotationActions;

// Decalarations
const SENT_FOR_FILLING = "SENT_FOR_FILLING";
const FILLER = "FILLER";
// const headerButtons = [
//   {
//     id: "notes",
//     key: "notes",
//     icon: ["far", "comments-alt"],
//     label: "Notes",
//     className: "",
//     tooltipMsg: "Leave a note",
//     isLeftBorder: true,
//     isRightBorder: false,
//   },
//   {
//     id: "attachments",
//     key: "attachments",
//     icon: ["far", "paperclip"],
//     label: "Attachments",
//     className: "",
//     tooltipMsg: "Attachments in this document",
//     isLeftBorder: false,
//     isRightBorder: false,
//   },
//   {
//     id: "quick_review",
//     key: "quick-review",
//     icon: null,
//     label: "Metalens",
//     className: "metalens-icon",
//     tooltipMsg: " Use metalens to review this document",
//     isLeftBorder: false,
//     isRightBorder: true,
//   },
// ];

const headerButtonsMap = {
  // SHARED_DOCUMENT: [...headerButtons],
  PERMA_SHARED_DOCUMENT: [],
};

class RevvEsignHeaderButtons extends Component {
  state = {};

  _onChangeView = newView => {
    if (this.props.view === newView && this.props.isOpen === true) {
      this.props.updateToolPaneData(false, "");
    } else {
      this.props.updateToolPaneData(true, newView);
    }
  };

  _headerBtn = (button, isMobileView) => (
    <span
      key={button.id}
      className={`recipientdocheader-button ${
        button.isLeftBorder && !isMobileView ? "" : ""
      } ${button.isRightBorder && !isMobileView ? "right-border" : ""} ${
        this.props.view === button.key ? "active" : ""
      } ${button.className} ${isMobileView ? "inside-dropdown" : ""}`}
      data-test={`recipientdocheaderbuttons-${button.id}-icon`}
      onClick={() => this._onChangeView(button.key)}
      tabIndex="0"
      onKeyDown={() => {}}
      role="button">
      {button.id === "quick_review" ? (
        <QuickReviewIcon
          active={false}
          className="recipient-side-quick-revision"
        />
      ) : (
        button.icon && (
          <FontAwesomeIcon
            icon={button.icon}
            className="recipientdocheaderbuttons-icon"
          />
        )
      )}
      {isMobileView && button.label}
    </span>
  );

  _getHeaderButtons = isMobileView => {
    let headerBtns = headerButtonsMap.SHARED_DOCUMENT;
    if (headerBtns && isMobileView) {
      headerBtns = headerBtns.filter(btn => btn.id !== "quick_review");
    }
    return headerBtns
      ? headerBtns.map(button =>
          isMobileView ? (
            this._headerBtn(button, isMobileView)
          ) : (
            <Tooltip
              placement={isMobileView ? "left" : "bottom"}
              align={{
                offset: [0, 4],
              }}
              overlay={button.tooltipMsg}>
              {this._headerBtn(button, isMobileView)}
            </Tooltip>
          ),
        )
      : null;
  };

  render() {
    let showDaysRemaining = false;
    let daysRemainingStr = null;
    if (this.props.link_expiry_time) {
      showDaysRemaining = true;
      const sDate = new Date();
      const eDate = new Date(this.props.link_expiry_time);
      const daysRemaining = dateDiff(sDate, eDate, "DAYS");
      if (daysRemaining && daysRemaining > 0) {
        showDaysRemaining = true;
        daysRemainingStr = `in ${daysRemaining} Day(s)`;
      }
    }
    const isMobileView = window.innerWidth <= 600;
    let isDocRejectBtn = false;
    if (
      this.props.stage === "SENT" &&
      this.props.recipientType === "ACCEPTOR" &&
      !this.props.acceptingStates
    ) {
      isDocRejectBtn = true;
    }
    let isDeclinedBtnEnabled = false;

    if (
      this.props.stage === SENT_FOR_FILLING &&
      this.props.recipientType === FILLER
    ) {
      isDeclinedBtnEnabled = true;
    }

    return (
      <div className="recipientdocheaderbuttons-container">
        {/* ------- Notes, Attachments and Metalense buttons section ------- */}
        {/* {!isMobileView && this._getHeaderButtons(isMobileView)} */}

        {/* ------- Download button section ------- */}
        {/* {!isMobileView &&
          this.props.documentPageType === "SHARED_DOCUMENT" &&
          !isDocRejectBtn &&
          !isDeclinedBtnEnabled && (
            <RecipientDocHeaderDownloadButton
              data-test="recipientdocheaderdownloadbutton"
              isSharedDocument={this.props.isSharedDocument}
              sharingHash={this.props.sharingHash}
              tooltipPlacement="bottom"
            />
          )} */}

        {/* ------- More button section------- */}

        {/* ------- Revv Info button section(for desktop devices and for magic links) ------- */}
        {/* {(this.props.documentPageType === "PERMA_SHARED_DOCUMENT" ||
          this.props.documentPageType === "MASTER_SHARED_DOCUMENT" ||
          !isMobileView) && ( */}
        {!this.props.isSigned && showDaysRemaining && (
          <span className="recipient-doc-header-expiry">
            <div
              className={`${
                !this.props.isAgreed
                  ? `esignband-link-expiry-text`
                  : `esignband-link-expiry-text-agreed`
              }`}>
              <FontAwesomeIcon
                icon={["far", "clock"]}
                className="esignband-link-expiry-icon"
              />{" "}
              Link expires{" "}
              <span className="esignband-link-expiry-days">
                {daysRemainingStr}
              </span>
            </div>
          </span>
        )}
        <span className="recipientdocheader-button">
          <EsignDocHeaderEvidenceSummary
            data-test="recipientdocheaderinfobutton"
            tooltipPlacement="left"
            sharingHash={this.props.sharingHash}
            docID={this.props.docID}
            signatories={this.props.signatories}
            docStage={this.props.doc_stage}
            docName={this.props.documentName}
            isLz={this.props.isLz}
            docObjectId={this.props.docObjectId}
            docObjectIdShared={this.props.docObjectIdShared}
          />
        </span>
        <span className="recipientdocheader-button">
          <RecipientDocHeaderMoreBtn
            isSharedDocument={this.props.isSharedDocument}
            sharingHash={this.props.sharingHash}
            docID={this.props.docID}
            isMobileView={isMobileView}
            isDocRejectBtn={isDocRejectBtn}
            documentPageType={this.props.documentPageType}
            isDeclinedBtnEnabled={isDeclinedBtnEnabled}
            documentName={this.props.documentName}>
            {isMobileView ? this._getHeaderButtons(isMobileView) : null}
          </RecipientDocHeaderMoreBtn>
        </span>
        {/* <span className="recipientdocheader-button">
          <EsignDocHeaderInfoButton
            data-test="recipientdocheaderinfobutton"
            tooltipPlacement="left"
            // isMobileView={isMobileView}
            // docType={this.props.documentPageType}
            // sharingHash={this.props.sharingHash}
          />
        </span> */}
        {/* )} */}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { isOpen, page, view } = state.ToolPaneStore;
  const { document: { isLocked, stage, documentSettings } = {}, content } =
    state.DocumentStore;
  const {
    recipientType,
    acceptingStates,
    docForwardingAllowed,
    doc_object_id: docObjectIdShared,
    is_lz: isLzShared,
  } = state.SharedDocument;
  const {
    doc_name: documentName,
    signatories,
    doc_stage,
    is_lz: isLzSign,
    doc_object_id: docObjectId,
    link_expiry_time,
    isSigned,
    isAgreed,
  } = state.RevvSignStore;
  let isLz = false;
  if (isLzSign) {
    isLz = isLzSign;
  } else if (isLzShared) {
    isLz = isLzShared;
  }
  return {
    isLocked,
    isOpen,
    page,
    view,
    content,
    stage,
    recipientType,
    acceptingStates,
    documentSettings,
    docForwardingAllowed,
    documentName,
    signatories,
    doc_stage,
    isLz,
    docObjectId,
    docObjectIdShared,
    link_expiry_time,
    isSigned,
    isAgreed,
  };
};

const mapDispatchToProps = {
  updateToolPaneData,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RevvEsignHeaderButtons);
